import EventIcon from "@mui/icons-material/Event";
import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { Box, Skeleton } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InterviewListTabs from "../../../components/discovery/interview/InterviewListTabs";
import { INTERVIEW_NAVIGATION_TABS } from "../../../constants";
import { HOME_SEGMENT_DIMENSIONS } from "../constants";
import HomeSegmentCard from "../HomeSegmentCard";
import HomeSegmentContent from "../HomeSegmentContent";
import HomeSegmentTitle from "../HomeSegmentTitle";

const rows = [...Array(14)].map(() => ({
  skeleton: (
    <Skeleton
      variant="rounded"
      height={20}
      sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
    />
  ),
}));

export const interviewTableSkeleton = (
  <TableContainer component={Paper}>
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell align="center">
            <EventIcon
              sx={{
                color: "#828282",
                fontSize: "1rem",
                alignSelf: "center",
              }}
            />
          </TableCell>
          <TableCell align="center">
            <LightbulbIcon
              sx={{
                color: "#828282",
                fontSize: "1rem",
                alignSelf: "center",
              }}
            />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell>{row.skeleton}</TableCell>
            <TableCell align="center">{row.skeleton}</TableCell>
            <TableCell align="center">{row.skeleton}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const InterviewsSegmentCardSkeleton = () => {
  const theme = useTheme();
  return (
    <HomeSegmentCard>
      <HomeSegmentTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InterpreterModeOutlinedIcon /> Interviews
        </Box>
      </HomeSegmentTitle>

      <HomeSegmentContent>
        <InterviewListTabs
          value={INTERVIEW_NAVIGATION_TABS.DRAFT}
          onChange={() => {}}
          sx={{
            borderBottom: HOME_SEGMENT_DIMENSIONS(theme).BORDER_BOTTOM,
          }}
          hideExportButton={true}
        />
        {interviewTableSkeleton}
      </HomeSegmentContent>
    </HomeSegmentCard>
  );
};

export default InterviewsSegmentCardSkeleton;
